import { Braces, ChartNoAxesCombined, PanelsTopLeft } from 'lucide-react'

import { defineArea, defineModule } from '@/lib/module-routes'

import {
  globalQueryExplorerRoute,
  globalReportBuilderRoute,
  globalReportsIndexRoute,
  queryExplorerRoute,
  reportBuilderRoute,
  reportDetailRoute,
  reportsIndexRoute,
  reportsListRoute,
} from './routes'
import { globalReportsRoute, reportsRoute } from './reports-route'

const reportsArea = defineArea({
  id: 'reports',
  label: 'Reports sections',
  product: 'reports',
  route: reportsRoute,
})
const globalReportsArea = defineArea({
  id: 'globalReports',
  label: 'Reports sections',
  product: 'reports',
  route: globalReportsRoute,
})

declare module '@/lib/module-routes' {
  interface Areas {
    reports: typeof reportsArea
    globalReports: typeof globalReportsArea
  }
}

export const reportingModule = defineModule({
  routes: [
    globalReportsRoute,
    globalReportsIndexRoute,
    globalReportBuilderRoute,
    globalQueryExplorerRoute,
    reportsRoute,
    reportsIndexRoute,
    reportsListRoute,
    reportBuilderRoute,
    queryExplorerRoute,
    reportDetailRoute,
  ],
  products: [
    {
      id: 'reports',
      label: 'Reports',
      description: 'Build and explore reports',
      icon: ChartNoAxesCombined,
      order: 70,
      routes: [reportsRoute, globalReportsRoute],
      entityFreeTo: '/reports/new',
    },
  ],
  areas: [reportsArea, globalReportsArea],
  sections: {
    reports: [{ id: 'reports', label: 'Reports', order: 10 }],
    globalReports: [{ id: 'reports', label: 'Reports', order: 10 }],
  },
  navigation: {
    reports: [
      {
        to: '/$entityId/reports/all',
        label: 'Saved reports',
        icon: PanelsTopLeft,
        section: 'reports',
        order: 10,
        activeOn: ['/$entityId/reports/new', '/$entityId/reports/$reportId'],
      },
      { to: '/$entityId/reports/query', label: 'Query explorer', icon: Braces, section: 'reports', order: 20 },
    ],
    globalReports: [
      { to: '/reports/query', label: 'Query explorer', icon: Braces, section: 'reports', order: 10 },
    ],
  },
})
